(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('ContractDTO', ContractDTO);

    ContractDTO.$inject = ['$resource', 'DateUtils'];

    function ContractDTO ($resource, DateUtils) {
        var resourceUrl =  'api/contractDTO/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.contractCreatedOn = DateUtils.convertDateTimeFromServer(data.contractCreatedOn);
                        data.contractModifiedOn = DateUtils.convertDateTimeFromServer(data.contractModifiedOn);
                        data.contractDate = DateUtils.convertLocalDateFromServer(data.contractDate);
                    }
                    return data;
                }
            }
        });
    }
})();
